import type React from 'react';
import { useContext, useEffect } from 'react';
import { GuardianContext } from '../components/GuardianProvider';
import { AppSidebar } from '../components/sidebar/AppSidebar';
import { ConversationList } from '../components/sidebar/ConversationList';
import { AppShell } from './AppShell';

/** Conversation mode layout: the app sidebar (conversation body) + the routed view. */
export const ConversationLayout: React.FC = () => {
  const { resumeChatConversation } = useContext(GuardianContext);

  // Each mode keeps its own conversation, so coming back here (e.g. via the Conversation tab)
  // picks the chat up where it was left rather than starting over.
  useEffect(resumeChatConversation, [resumeChatConversation]);

  return <AppShell sidebar={<AppSidebar body={<ConversationList />} />} />;
};
